import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  // Filter out non-string/non-valid values before processing
  const filtered = inputs.filter(input => {
    if (input === null || input === undefined || input === false) return false;
    if (typeof input === 'object' && !Array.isArray(input)) {
      // Handle conditional objects like { 'class-name': boolean }
      return true;
    }
    if (typeof input === 'string') return true;
    if (Array.isArray(input)) return true;
    // Filter out numbers, functions, etc. that could cause trim() errors
    return false;
  });
  return twMerge(clsx(filtered));
}
